import { render, staticRenderFns } from "./Cafe.vue?vue&type=template&id=67234e44"
import script from "./Cafe.vue?vue&type=script&lang=js"
export * from "./Cafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports